export const technical = [
  {
    'dept': 'Engineering',
    'number': '205-1',
    'title': 'Engineering Analysis 1',
    'description': 'Linear Algebra, MATLAB Programming'
  },
  {
    'dept': 'Engineering',
    'number': '205-2',
    'title': 'Engineering Analysis 2',
    'description': 'Mechanics, Stress & Strain'
  },
  {
    'dept': 'Engineering',
    'number': '205-3',
    'title': 'Engineering Analysis 3',
    'description': 'Dynamics, Introduction to Differential Equations'
  },
  {
    'dept': 'Design',
    'number': '106-1',
    'title': 'Design Thinking & Communication 1'
  },
  {
    'dept': 'Design',
    'number': '106-2',
    'title': 'Design Thinking & Communication 2'
  },
  {
    'dept': 'Math',
    'number': '230',
    'title': 'Multivariable Differential Calculus'
  },
  {
    'dept': 'Math',
    'number': '234',
    'title': 'Multivariable Integration and Vector Calculus'
  },
  {
    'dept': 'IEMS',
    'number': '202',
    'title': 'Probability'
  },
  {
    'dept': 'IEMS',
    'number': '303',
    'title': 'Statistics'
  },
  {
    'dept': 'RTVF',
    'number': '202',
    'title': 'Analysis of Media Text'
  },
  {
    'dept': 'History',
    'number': '2XX',
    'title': 'Medieval Scottish History**'
  },
  {
    'dept': 'Earth Science',
    'number': '2XX',
    'title': 'Earth Dynamics**'
  }, {
    'dept': 'Physics',
    'number': '135-3',
    'title': 'Electricity, Waves, & Magnetism'
  },

]

export const econ = [
  {
    'number': 201,
    'title': 'Intro to Microeconomics'
  },
  {
    'number': 201,
    'title': 'Intro to Macroeconomics'
  },
  {
    'number': '310-1',
    'title': 'Intermediate Microeconomics 1'
  },
  {
    'number': '310-2',
    'title': 'Intermediate Microeconomics 2'
  },
  {
    'number': 311,
    'title': 'Intermediate Macroeconomics'
  },
  {
    'number': '381-1',
    'title': 'Applied Econometrics 1'
  },
  {
    'number': '381-2',
    'title': 'Applied Econometrics 2'
  },
  {
    'number': 'FE 310',
    'title': 'Principles of Finance'
  },
  {
    'number': 'FE 312',
    'title': 'Investments'
  },
  {
    'number': 'FE 314',
    'title': 'Derivatives'
  },
  {
    'number': 'FE 316',
    'title': 'International Finance'
  },

]

export const cs = [
  {
    'number': 101,
    'title': 'An Introduction to Computer Science for Everyone'
  },
  {
    'number': 111,
    'title': 'Fundamentals to Computer Programming 1',
    'technology': 'Meta'
  },
  {
    'number': 205,
    'title': 'Fundamentals of Computer System Software',
    'technology': 'Assembly Code'
  },
  {
    'number': 211,
    'title': 'Fundamentals to Computer Programming 2',
    'technology': 'C++'
  },
  {
    'number': 212,
    'title': 'Mathamatic Foundations of Computer Science'
  },
  {
    'number': 213,
    'title': 'Computer Systems',
    'technology': 'UNIX, C'
  },
  {
    'number': 214,
    'title': 'Data Structures and Algorithms',
    'technology': 'C#'
  },
  {
    'number': 195,
    'title': 'Introduction to Robotics Laboratory',
    'technology': 'Python, ROS'
  },
  {
    'number': 330,
    'title': 'Human Computer Interaction',
    'technology': 'HTML5, CSS3, Javascript'
  },
  {
    'number': '3XX',
    'title': 'Computer Graphics(Level 11)**',
    'technology': 'C++, OpenGL'
  },
  {
    'number': '3XX',
    'title': 'Database Systems**',
    'technology': 'PostgreSQL'
  },
  {
    'number': '336',
    'title': 'Design and Analysis of Algorithms'
  },
  {
    'number': 352,
    'title': 'Machine Perception of Music and Audio',
    'technology': 'Python'
  },
  {
    'number': 348,
    'title': 'Introduction to Artificial Intelligence',
    'technology': 'Python'
  },
  {
    'number': 349,
    'title': 'Machine Learning',
    'technology': 'Python'
  }, {
    'number': 366,
    'title': 'Algorithms'
  },
  {
    'number': 394,
    'title': 'Software Project Management',
    'technology': 'Angular.JS, Node, Express, PostgreSQL, Appgyver, SASS'
  },
  {
    'number': 395,
    'title': 'Swarm Robotics',
    'technology': 'C++'
  },
  {
    'number': 395,
    'title': 'Wireless and Mobile Health',
    technology: 'Java, Android Mobile, Android Wear'
  },
  {
    number: 395,
    title: 'Software Construction',
    technology: 'Java, JUnit'
  },
  {
    'number': 395,
    'title': 'Innovation in Technology & Journalism',
    technology: 'Java, JavaScript, Angular.JS'
  }
]

export const clubs = [
  {
    'name': 'Delta Tau Delta Fraternity',
    'start': 'Winter 2014',
    'end': 'Spring 2017',
    'description': 'Active brother and leader in the chapter. Leadership discussed in leadership section',
    'list_title': 'Positions',
    'list': [
      {
        'title': 'Guide',
        'description': 'Holds a seat on the Executive Board and is in charge of the ritual, initiation, and secrets of the fraternity'
      },
      {
        'title': 'Brotherhood Chair',
        'description': ' Holds a seat on the Administrative Board and is responsible for all programming promoting comradery and brotherhood'
      },
      {
        'title': 'Housing Chair',
        'description': ' Independent position responsible for managing the house and acting as a liaison between the chapter and our housing corporation'
      }
    ]
  },
  {
    'name': 'Form & Function Marketing',
    'start': 'Fall 2014',
    'end': 'Spring 2017',
    'link': 'http://www.formandfunctionmarketing.com',
    'description': 'Northwestern student marketing agency that provides free consulting to local businesses, non-profits, and student organizations',
    'list_title': 'Positions',
    'list': [
      {
        'title': 'VP - Technology - 2017',
        'description': 'Created this position as the technological side of the organization. Responsibilities include: SEO, technical consulting to teams, small development projects and IT Administration '
      },
      {
        'title': 'Account Executive - 2016',
        'description': 'Lead 7 person team for projects with various clients'
      },
      {
        'title': 'General Member - 2014-2016'
      }
    ]
  },
  {
    'name': 'Peer Leader',
    'start': 'Fall 2011',
    'end': 'Spring 2013',
    'description': 'Advised and mentored a group of incoming Alexander Dawson School freshmen throughout the year.',
    'list_title': null,
    'list': null
  },
  {
    'name': 'Conduct Committee',
    'start': 'Fall 2010',
    'end': 'Spring 2012',
    'description': 'Elected by peers to serve on the Alexander Dawson School disciplinary committee run by students and faculty.',
    'list_title': null,
    'list': null
  },
  {
    'name': 'Northwestern Sketch Television',
    'start': 'Fall 2013',
    'end': 'Spring 2014',
    'description': 'Associate Producer',
    'list_title': null,
    'list': null
  }
]
